export const documentActionTypes = {
    'SET_USER_DOCUMENT': 'SET_USER_DOCUMENT',
    'ADD_CREATED_DOCUMENT': 'ADD_CREATED_DOCUMENT',
    'SET_USER_DELETED_DOCUMENT': 'SET_USER_DELETED_DOCUMENT',
    'SET_SHARED_TO_USER_DOCUMENT': 'SET_SHARED_TO_USER_DOCUMENT',
    'REMOVE_DELETED_DOCUMENT': 'REMOVE_DELETED_DOCUMENT',
    'PASS_GET_COMMENT_FUNCTION' : 'PASS_GET_COMMENT_FUNCTION'
}